<template>
  <div class="o-card">
    <loading v-if="getBatteryLoadingById || !batteryIsLoaded"></loading>
    <NotFound v-else-if="!batteryItem"></NotFound>
    <no-auth v-else-if="!hasAuthorize.edit || !hasAuthorize.getById"></no-auth>
    <LockedView v-else-if="!batteryItem.isPermission || batteryItem.isLocked">
      {{ $t("batteryDetail.batteryEditLocked") }}
      <div class="u-margin-top">
        <router-link
          :to="{ name: 'batteries-detail', params: { id: batteryId } }"
        >
          <Button variant="primary">
            <i class="icofont-arrow-left"></i> {{ $t("common.back") }}
          </Button>
        </router-link>
      </div>
    </LockedView>
    <div v-else>
      <battery-features edit :form="batteryItem"></battery-features>
    </div>
  </div>
</template>

<script>
import Loading from "../Base/Loading/Loading.vue";
import batteryMixin from "@/mixins/batteryMixin";
import BatteryFeatures from "../Batteries/BatteryForm/BatteryFeatures.vue";
import NotFound from "../Base/NotFound.vue";
import LockedView from "@/components/LockedView/index.vue";
import authorize from "../Batteries/authorize";
import Button from "../Base/Button.vue";
export default {
  components: { Loading, BatteryFeatures, NotFound, LockedView, Button },
  mixins: [authorize, batteryMixin],
  data() {
    return {
      batteryId: null,
    };
  },
  created() {
    this.batteryId = Number(this.$route.params.id);
    // devamını mixin yapıyor.
  },
};
</script>

<style></style>
